import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  get_headers,
  RETRIEVE_SERVICES,
}  from '@/utils/constants/constants.js';
import axios from 'axios';


export default {
  name: "VerificationResults",
  mixins: [alert_mixin],
  props: {
    profile_role_form_id: {
        type: [String, Number],
        required: true
    }
  },
  components: {
    NavigationBackButton,
    GlobalTable,
  },
  data: () => ({
    headers: get_headers(),
    expanded_service: null,
    lead_id: null,
    expanded_index: null,
    active_tabs: ['Forms'],
    is_trust_form_open: true,
    last_updated: "Jul 31, 2025",
    form_name: '',
    verification_services: [],
    expanded_cards: [],
    active_main_tab: 'Answers', 
    main_tabs: [
      {
        label: "Answers",
      },
      {
        label: "Verification",
      },
    ],
    verification_results: [
        {
            type: "idv",
            label: "IDV Results",
            date: "Apr 1, 2023",
            status: "Verified",
            details: {
                status: "Verified",
                name_match: "John Doe",
                verification_id: "IDV-001",
                officer: "Auto Verification",
                priority: "High"
            }
        },
        {
            type: "cipc",
            label: "CIPC Results",
            date: "Apr 1, 2023",
            status: "Failed",
            details: {
                status: "Failed",
                company: "ABC PTY LTD",
                registration_number: "2019/123456/07",
                officer: "System Auto",
                priority: "Normal"
            }
        },
        {
            type: "directors",
            label: "Directors Search",
            date: "Apr 1, 2023",
            status: "Pending",
            details: {
                directors: ["Jane Doe", "John Smith"],
                count: 2,
                source: "CIPC"
            }
        },
        {
            type: "address",
            label: "Address Search",
            date: "Apr 1, 2023",
            status: "Pending",
            details: {
                address: "123 Main St, Sandton, 2196",
                verified: false,
                geocode_match: "Low"
            }
        }
    ],

    
  }),
  mounted() {

    this.lead_id =
            this.$route.params.lead_id ??
            this.$route.params.id ??
            this.$route.query.lead_id ??
            null;

        if (!this.lead_id) {
            this.show_error("No lead ID found. Check your route.");
        }

    this.get_services();
  },
  methods: {
    toggle_tab(tab) {
      if (this.active_tabs.includes(tab)) {
        this.active_tabs = this.active_tabs.filter(t => t !== tab);
      } else {
        this.active_tabs.push(tab);
      }
    },
    toggle_program() {
      this.is_trust_form_open = !this.is_trust_form_open;
    },
    toggle_expanded(index) {
      this.expanded_index = this.expanded_index === index ? null : index;
    },
    redirect_to_verification_results() {
      this.$router.push({
        path: "/verification_results",
      });
    },
    format_key(str) {
      return str.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    },

    toggle_service_details(index) {
        this.expanded_service = this.expanded_service === index ? null : index;
    },

    get_service_icon(type) {
        if (type === 'idv') {
            return 'bi-person-check';
        } else if (type === 'cipc') {
            return 'bi-building-check';
        } else if (type === 'directors') {
            return 'bi-people';
        } else if (type === 'address') {
            return 'bi-geo-alt';
        } else {
            return 'bi-file-earmark';
        }
    },




    get_servicecard_class(status) {
        if (status === 'Verified') return 'verified';
        if (status === 'Pending') return 'pending';
        if (status === 'Failed') return 'failed';
        return '';
    },



    get_services() {
      axios.get(RETRIEVE_SERVICES, {
        headers: this.headers,
      })
      .then(response => {
        const parsed_response = JSON.parse(response.data);
        if (parsed_response.status === "success" && parsed_response.data) {
          this.verification_services = parsed_response.data.map(service => ({
            ...service,
            selected: false
          }));
        } else {
          this.verification_services = [];
        }
      })
      .catch(error => {
        this.show_error("Error loading services: " + (error.response?.data?.message || error.message));
      });
    },



    toggle_card(index) {
        if (this.expanded_cards.includes(index)) {
        this.expanded_cards = this.expanded_cards.filter(i => i !== index);
        } else {
        this.expanded_cards.push(index);
        }
    },


  },
};
